import { render, staticRenderFns } from "./VideoRoomTests.vue?vue&type=template&id=d7c23264"
import script from "./VideoRoomTests.vue?vue&type=script&lang=js"
export * from "./VideoRoomTests.vue?vue&type=script&lang=js"
import style0 from "./VideoRoomTests.vue?vue&type=style&index=0&id=d7c23264&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports